import * as React from "react";
import { ChakraProvider } from "@chakra-ui/react";
import themes from 'themes';
import Router from "routes";
import Fonts from "themes/fonts";
import PixelUtil from "utils/pixel-utils";
import AppConsts from "libs/appconst";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";

export const App = (): React.ReactElement => {
    React.useEffect(() => {

        document.title = AppConsts.APP_NAME;

        PixelUtil.Initialize(AppConsts.FACEBOOK_PIXEL_ID, AppConsts.GOOGLE_ANALYTICS_TRACKING_CODE);
        PixelUtil.PageView();

        //if (AppConsts.GOOGLE_ANALYTICS_TRACKING_CODE) {


            //ReactGA.initialize(AppConsts.GOOGLE_ANALYTICS_TRACKING_CODE);

            //ReactGA.initialize(AppConsts.GOOGLE_ANALYTICS_TRACKING_CODE);
            //ReactGA4.
            //ReactGA.pageview("homepage");
            //ReactGA.set({ page: "homepage" });
        //}
    }, []);

    return (
        <ChakraProvider theme={themes}>
            <Fonts />
            <Router />
        </ChakraProvider>
    );
};